// extracted by extract-css-chunks-webpack-plugin
module.exports = {"YCToast":"OXiIcvYQ","YcCoinContainer":"e6wb7FWJ","contentContainer":"KTxPp8hb","text":"s2wYow_o","description":"a6QE_61q"};